import { URL_PUBLIQUE } from '../plateforme';
import { useState, useEffect } from 'react';
import ComptesParEquipe from './ComptesParEquipe';
import { PanneauKwixeo, LigneKwixeoClub } from './FacturationKwixeo';
import SuppressionClub from './SuppressionClub';
import ConsoleProjets from './ConsoleProjets';
import { ConsoleRetours, ConsoleFaq } from './ConsoleRetours';
import { getClubs, getClubDetail, majClub, creerClubComplet, rechercherCompte,
         resetMdpEditeur, activerCompte, roleCompte, setAbonnement, setEquipeCourante, getFondateur, setFondateur } from '../api';

const ROLE = { super_admin:'Éditeur', admin_club:'Admin club', admin:'Admin club', coach:'Coach',
               tresorier:'Trésorier', admin_3mt:'Trésorier', joueur:'Joueur' };
const ABO = {
  illimite:      { lib:'Sans échéance',  fg:'#8b949e', bg:'rgba(139,148,158,.12)' },
  actif:         { lib:'Actif',          fg:'#22c55e', bg:'rgba(34,197,94,.12)' },
  a_renouveler:  { lib:'À renouveler',   fg:'#93c5fd', bg:'rgba(59,130,246,.14)' },
  grace:         { lib:'Délai de grâce', fg:'#fdba74', bg:'rgba(249,115,22,.14)' },
  lecture_seule: { lib:'Lecture seule',  fg:'#fca5a5', bg:'rgba(var(--danger-rgb),.14)' },
  suspendu:      { lib:'Suspendu',       fg:'#fca5a5', bg:'rgba(var(--danger-rgb),.14)' },
  essai:         { lib:'Essai',          fg:'#c4b5fd', bg:'rgba(139,92,246,.16)' },
  essai_termine: { lib:'Essai terminé',  fg:'#fca5a5', bg:'rgba(var(--danger-rgb),.14)' },
};
const frDate = iso => iso ? iso.split('-').reverse().join('/') : '';
const dansUnMois = () => { const d = new Date(); d.setMonth(d.getMonth() + 1); return d.toISOString().slice(0, 10); };
function BadgeAbo({ abo }) {
  const s = ABO[abo?.statut] || ABO.illimite;
  const lib = abo?.statut === 'essai' ? `Essai · ${abo.restants} j` : s.lib;
  return <span style={{ fontSize:10, fontWeight:700, color:s.fg, background:s.bg, borderRadius:5,
                        padding:'2px 7px', letterSpacing:.5, textTransform:'uppercase', whiteSpace:'nowrap' }}>{lib}</span>;
}

const champ = { width:'100%', background:'var(--bg)', border:'1px solid var(--border)', borderRadius:9,
                padding:'10px 12px', color:'var(--text)', fontSize:14 };

/** Bloc d'identifiants à transmettre, avec copie en un clic. */
function Identifiants({ titre, username, password, onFermer }) {
  const texte = `Identifiant : ${username}\nMot de passe : ${password}\nAdresse : ${URL_PUBLIQUE}`;
  return (
    <div className="card" style={{ marginBottom:14, borderColor:'rgba(34,197,94,.45)', background:'rgba(34,197,94,.06)' }}>
      <div style={{ fontSize:11, fontWeight:700, color:'#22c55e', letterSpacing:2, textTransform:'uppercase', marginBottom:8 }}>✓ {titre}</div>
      <div style={{ fontFamily:'monospace', fontSize:13.5, lineHeight:1.8, background:'var(--bg)', borderRadius:8, padding:'10px 13px' }}>
        <div>Identifiant : <b>{username}</b></div>
        <div>Mot de passe : <b style={{ color:'#22c55e' }}>{password}</b></div>
      </div>
      <div style={{ fontSize:11.5, color:'var(--muted)', margin:'9px 0' }}>Un email avec ces accès est parti. Ce mot de passe ne sera plus affiché.</div>
      <div style={{ display:'flex', gap:8 }}>
        <button className="btn btn-secondary" style={{ width:'auto', padding:'8px 14px', fontSize:12 }}
                onClick={() => navigator.clipboard?.writeText(texte)}>📋 Copier</button>
        <button className="btn btn-secondary" style={{ width:'auto', padding:'8px 14px', fontSize:12 }} onClick={onFermer}>Fermer</button>
      </div>
    </div>
  );
}

export default function ConsolePage() {
  const [onglet, setOnglet] = useState('clubs');
  const [toast, setToast]   = useState(null);
  const notifier = (msg, type = 'success') => { setToast({ msg, type }); setTimeout(() => setToast(null), 3200); };

  return (
    <>
      <div className="page-header">
        <div className="eyebrow">Administration Équipote</div>
        <h1>🛠️ Console</h1>
        <div className="sub">Clubs clients et dépannage des comptes</div>
      </div>
      <div className="tabs">
        {[['clubs','🏛️ Clubs'],['retours','💬 Retours'],['projets','🗺️ Bientôt'],['faq','❓ FAQ'],['depannage','🔧 Dépannage']].map(([k,l]) => (
          <button key={k} className={`tab-btn ${onglet===k?'active':''}`} onClick={() => setOnglet(k)}>{l}</button>
        ))}
      </div>
      <div className="section">
        {onglet === 'clubs' ? <Clubs notifier={notifier} /> : onglet === 'projets' ? <ConsoleProjets notifier={notifier} />
          : onglet === 'retours' ? <ConsoleRetours notifier={notifier} /> : onglet === 'faq' ? <ConsoleFaq notifier={notifier} /> : <Depannage notifier={notifier} />}
      </div>
      {toast && <div className={`toast ${toast.type}`}>{toast.msg}</div>}
    </>
  );
}

// ── Clubs ───────────────────────────────────────────────────────────────────
function Clubs({ notifier }) {
  const [clubs, setClubs]     = useState([]);
  const [ouvert, setOuvert]   = useState(null);
  const [recherche, setRecherche] = useState('');
  const [voirSuspendus, setVoirSuspendus] = useState(false);
  const [detail, setDetail]   = useState(null);
  const [creation, setCreation] = useState(false);
  const [cree, setCree]       = useState(null);
  const [f, setF]             = useState({});
  const [envoi, setEnvoi]     = useState(false);

  const [fondateur, setInfosFondateur] = useState(null);
  const charger = () => {
    getFondateur().then(setInfosFondateur).catch(() => {});
    return getClubs().then(setClubs).catch(e => notifier(e.message, 'error'));
  };
  useEffect(() => { charger(); }, []);

  async function ouvrir(id) {
    if (ouvert === id) { setOuvert(null); return; }
    setOuvert(id); setDetail(null);
    try { setDetail(await getClubDetail(id)); } catch (e) { notifier(e.message, 'error'); }
  }

  async function creer(e) {
    e.preventDefault();
    setEnvoi(true);
    try {
      const r = await creerClubComplet({
        club:   { nom: f.nom, code_ffhb: f.code || undefined, ville: f.ville,
                  essai: f.essai !== false, abonnement_fin: f.essai === false ? (f.fin || undefined) : undefined },
        admin:  { prenom: f.aPrenom, nom: f.aNom, email: f.aEmail },
        equipe: { nom: f.equipe || 'Seniors', categorie: f.categorie }
      });
      setCree({ club: f.nom, ...r.compte });
      setCreation(false); setF({}); charger();
    } catch (err) { notifier(err.message, 'error'); }
    finally { setEnvoi(false); }
  }

  async function abonnement(c, data) {
    try {
      const r = await setAbonnement(c.id, data);
      notifier(r.abonnement_fin ? `Échéance : ${frDate(r.abonnement_fin)}` : 'Abonnement sans échéance');
      charger();
    } catch (e) { notifier(e.message, 'error'); }
  }

  async function basculer(c) {
    const actif = !c.actif;
    if (!actif && !window.confirm(`Suspendre ${c.nom} ? Ses utilisateurs n'auront plus accès à leurs données.`)) return;
    try { await majClub(c.id, { ...c, actif }); notifier(actif ? 'Club réactivé' : 'Club suspendu'); charger(); }
    catch (e) { notifier(e.message, 'error'); }
  }

  function consulter(equipeId) {
    setEquipeCourante(equipeId);
    // Le rechargement met l'en-tête aux couleurs du club consulté ; la consigne fait
    // ouvrir ses statistiques au lieu de la console
    try { sessionStorage.setItem('equipote:ouvrir', 'stats'); } catch {}
    window.location.href = window.location.pathname;
  }

  const set = k => e => setF({ ...f, [k]: e.target.value });

  // Recherche insensible aux accents et à la casse ; suspendus rangés à part
  const normaliser = s => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const correspond = cl => !recherche.trim() || [cl.nom, cl.ville, cl.code_ffhb, cl.email]
    .some(v => normaliser(v).includes(normaliser(recherche.trim())));
  const trouves = clubs.filter(correspond);
  const actifs = trouves.filter(cl => cl.actif);
  const suspendus = trouves.filter(cl => !cl.actif);
  const afficherSuspendus = voirSuspendus || (!!recherche.trim() && suspendus.length > 0);

  const carte = c => (
        <div key={c.id}>
          <div className="card card-row" onClick={() => ouvrir(c.id)}
               style={{ cursor:'pointer', marginBottom: ouvert === c.id ? 0 : 8, opacity: c.actif ? 1 : .55 }}>
            <div style={{ display:'flex', alignItems:'center', gap:11 }}>
              <span style={{ width:12, height:12, borderRadius:3, flexShrink:0,
                             background: `linear-gradient(135deg, ${c.couleur || '#e63946'} 50%, ${c.couleur2 || c.couleur || '#e63946'} 50%)` }} />
              <div>
                <div style={{ fontSize:14, fontWeight:700, display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
                  {c.nom} <BadgeAbo abo={c.abo} />
                  {!!c.fondateur && <span style={{ fontSize:10, fontWeight:700, color:'#eab308', background:'rgba(234,179,8,.14)',
                                                   borderRadius:5, padding:'2px 7px', letterSpacing:.5, textTransform:'uppercase' }}>★ Fondateur</span>}
                  {c.demande && <span style={{ fontSize:10, fontWeight:700, color:'#22c55e', background:'rgba(34,197,94,.14)',
                                               borderRadius:5, padding:'2px 7px', letterSpacing:.5, textTransform:'uppercase' }}>
                                  💬 Veut s'abonner</span>}
                  {c.abo?.fin && <span style={{ fontSize:11, color:'var(--muted)', fontWeight:400 }}>→ {frDate(c.abo.fin)}</span>}</div>
                <div style={{ fontSize:11.5, color:'var(--muted)', marginTop:2 }}>
                  {c.ville ? `${c.ville} · ` : ''}{c.code_ffhb || 'sans code FFHB'} · {c.nb_equipes} équipe{c.nb_equipes>1?'s':''} · {c.nb_joueurs} joueur{c.nb_joueurs>1?'s':''} · {c.nb_comptes} compte{c.nb_comptes>1?'s':''}
                </div>
              </div>
            </div>
            <span style={{ color:'var(--muted)' }}>{ouvert === c.id ? '▾' : '▸'}</span>
          </div>

          {ouvert === c.id && (
            <div style={{ border:'1px solid var(--border)', borderTop:'none', borderRadius:'0 0 12px 12px',
                          padding:'12px 14px', marginBottom:8, background:'rgba(255,255,255,.015)' }}>
              {!detail ? <div style={{ color:'var(--muted)', fontSize:13 }}>Chargement…</div> : (
                <>
                  <div style={{ fontSize:11, color:'var(--muted)', letterSpacing:1, textTransform:'uppercase', marginBottom:6 }}>Équipes</div>
                  {detail.equipes.map(e => (
                    <div key={e.id} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'6px 0', fontSize:13 }}>
                      <span>{e.nom} <span style={{ color:'var(--muted)', fontSize:11.5 }}>· {e.nb_joueurs} joueurs · {e.nb_matchs} matchs</span></span>
                      <button onClick={() => consulter(e.id)}
                              style={{ background:'none', border:'1px solid var(--border)', borderRadius:7, color:'var(--text)',
                                       fontSize:11, padding:'5px 10px', cursor:'pointer' }}>Consulter →</button>
                    </div>
                  ))}
                  <div style={{ fontSize:11, color:'var(--muted)', letterSpacing:1, textTransform:'uppercase', margin:'14px 0 6px' }}>Comptes</div>
                  <ComptesParEquipe clubId={c.id} notifier={notifier} />
                  {c.demande && (
                    <div style={{ background:'rgba(34,197,94,.07)', border:'1px solid rgba(34,197,94,.35)', borderRadius:10,
                                  padding:'11px 13px', marginTop:14, fontSize:12.5, lineHeight:1.7 }}>
                      <div style={{ fontWeight:700, color:'#22c55e', marginBottom:4 }}>
                        Demande d'abonnement du {frDate(c.demande.created_at.slice(0,10))}</div>
                      <div>Formule : <b>{({ fondateur:'★ fondateur — 150 € TTC la saison, garanti deux saisons', annuel:'saison — 250 € TTC', mensuel:'mensuelle — 25 € TTC / mois' })[c.demande.formule]}</b></div>
                      <div>Facturation : <b>{c.demande.email_facturation}</b></div>
                      {c.demande.adresse && <div>Adresse : {c.demande.adresse}</div>}
                      {c.demande.message && <div style={{ color:'var(--muted)', marginTop:4, fontStyle:'italic' }}>« {c.demande.message} »</div>}
                      <div style={{ color:'var(--muted)', fontSize:11.5, marginTop:6 }}>
                        Facture envoyée et réglée ? « Convertir » ou « +1 an » clôt la demande.</div>
                    </div>)}
                  <div style={{ fontSize:11, color:'var(--muted)', letterSpacing:1, textTransform:'uppercase', margin:'16px 0 8px' }}>Abonnement</div>
                  <LigneKwixeoClub club={c} notifier={notifier} recharger={charger} />
                  <label style={{ display:'flex', gap:8, alignItems:'center', fontSize:12.5, cursor:'pointer', marginBottom:10 }}>
                    <input type="checkbox" checked={!!c.fondateur} style={{ accentColor:'#eab308', width:16, height:16 }}
                           onChange={async e => { try { await setFondateur(c.id, e.target.checked); charger(); }
                                                  catch (err) { notifier(err.message, 'error'); } }} />
                    ★ Tarif fondateur — 150 € TTC la saison, garanti deux saisons
                  </label>
                  <div style={{ display:'flex', gap:6, flexWrap:'wrap', alignItems:'center' }}>
                    <input type="date" value={c.abonnement_fin || ''} aria-label="Fin d'abonnement"
                           onChange={e => e.target.value && abonnement(c, { fin: e.target.value })}
                           style={{ ...champ, width:'auto', padding:'7px 9px', fontSize:12.5, colorScheme:'dark' }} />
                    {(c.essai
                      ? [['+7 jours d\'essai',{ prolonger_essai:7 }],['✓ Convertir — 1 an',{ convertir:{ ans:1 } }]]
                      : [['+1 mois',{ prolonger:{ mois:1 } }],['+1 an',{ prolonger:{ ans:1 } }]]).map(([l,p]) => (
                      <button key={l} className="btn btn-secondary" style={{ width:'auto', padding:'7px 12px', fontSize:12 }}
                              onClick={() => abonnement(c, p)}>{l}</button>))}
                    <button className="btn btn-secondary" style={{ width:'auto', padding:'7px 12px', fontSize:12 }}
                            onClick={() => abonnement(c, { illimite:true })}>Sans échéance</button>
                  </div>
                  <div style={{ fontSize:11, color:'var(--muted)', marginTop:6, lineHeight:1.5 }}>
                    {c.essai
                      ? <>« Convertir » met fin à l'essai : l'abonnement d'un an démarre aujourd'hui.</>
                      : <>« +1 an » part de l'échéance si elle est à venir, d'aujourd'hui si elle est dépassée.</>}
                  </div>
                  <button onClick={() => basculer(c)} className="btn btn-secondary"
                          style={{ width:'auto', padding:'8px 14px', fontSize:12, marginTop:14 }}>
                    {c.actif ? 'Suspendre le club' : 'Réactiver le club'}
                  </button>
                  {c.actif
                    ? <div style={{ fontSize: 11.5, color: 'var(--muted)', marginTop: 6 }}>Pour supprimer un club, suspendez-le d'abord.</div>
                    : <SuppressionClub club={c} notifier={notifier} apres={() => { setOuvert(null); charger(); }} />}
                </>
              )}
            </div>
          )}
        </div>
  );

  return (
    <>
      {cree && <Identifiants titre={`${cree.club} créé — accès de l'admin`} username={cree.username}
                             password={cree.password} onFermer={() => setCree(null)} />}

      {!creation ? (<>
        <button className="btn btn-primary" style={{ marginBottom:12 }} onClick={() => { setCreation(true); setF({ essai: true, fin: dansUnMois() }); }}>+ Nouveau club</button>
        {fondateur && (
          <div style={{ fontSize:12.5, color:'var(--muted)', marginBottom:16 }}>
            <span style={{ color:'#eab308', fontWeight:700 }}>★ Offre fondateur</span> : {fondateur.prises} place{fondateur.prises > 1 ? 's' : ''} prise{fondateur.prises > 1 ? 's' : ''} sur {fondateur.total}
            {fondateur.restantes === 0 && <b style={{ color:'var(--text)' }}> — complète</b>}
          </div>)}
      </>
      ) : (
        <form className="card" style={{ marginBottom:16 }} onSubmit={creer}>
          <div style={{ fontSize:12, fontWeight:700, color:'var(--accent)', letterSpacing:1, textTransform:'uppercase', marginBottom:14 }}>Nouveau club</div>

          <div style={{ fontSize:11, color:'var(--muted)', letterSpacing:1, textTransform:'uppercase', marginBottom:7 }}>Le club</div>
          <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr', gap:9, marginBottom:9 }}>
            <input style={champ} placeholder="Nom du club *" value={f.nom||''} onChange={set('nom')} required />
            <input style={champ} placeholder="Code FFHB" value={f.code||''} onChange={set('code')} inputMode="numeric" maxLength={7} />
          </div>
          <input style={{ ...champ, marginBottom:16 }} placeholder="Ville" value={f.ville||''} onChange={set('ville')} />

          <div style={{ fontSize:11, color:'var(--muted)', letterSpacing:1, textTransform:'uppercase', marginBottom:7 }}>Son administrateur</div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:9, marginBottom:9 }}>
            <input style={champ} placeholder="Prénom *" value={f.aPrenom||''} onChange={set('aPrenom')} required />
            <input style={champ} placeholder="Nom *" value={f.aNom||''} onChange={set('aNom')} required />
          </div>
          <input style={{ ...champ, marginBottom:16 }} type="email" placeholder="Email * — ses accès lui seront envoyés"
                 value={f.aEmail||''} onChange={set('aEmail')} required />

          <div style={{ fontSize:11, color:'var(--muted)', letterSpacing:1, textTransform:'uppercase', marginBottom:7 }}>Sa première équipe</div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:9, marginBottom:14 }}>
            <input style={champ} placeholder="Nom (Seniors)" value={f.equipe||''} onChange={set('equipe')} />
            <input style={champ} placeholder="Catégorie" value={f.categorie||''} onChange={set('categorie')} />
          </div>

          <label style={{ display:'flex', gap:10, alignItems:'flex-start', cursor:'pointer', marginBottom:12 }}>
            <input type="checkbox" checked={f.essai !== false} onChange={e => setF({ ...f, essai: e.target.checked })}
                   style={{ width:18, height:18, marginTop:1, accentColor:'var(--accent)' }} />
            <div>
              <div style={{ fontSize:13.5, fontWeight:700 }}>Période d'essai d'un mois</div>
              <div style={{ fontSize:11.5, color:'var(--muted)', marginTop:2, lineHeight:1.5 }}>
                Toutes les fonctions, puis blocage complet. Vous êtes prévenu trois jours avant la fin.</div>
            </div>
          </label>
          {f.essai === false && <>
            <div style={{ fontSize:11, color:'var(--muted)', letterSpacing:1, textTransform:'uppercase', marginBottom:7 }}>Fin d'abonnement</div>
            <input type="date" style={{ ...champ, colorScheme:'dark', marginBottom:4 }} value={f.fin||''} onChange={set('fin')} />
            <div style={{ fontSize:11, color:'var(--muted)', marginBottom:16 }}>Laissez vide pour un club sans échéance.</div>
          </>}

          <div style={{ fontSize:11.5, color:'var(--muted)', marginBottom:12, lineHeight:1.6 }}>
            Le code FFHandball (7 chiffres) permet l'import des feuilles de match. Il figure sur chaque feuille, à côté du nom du club.
          </div>
          <div style={{ display:'flex', gap:9 }}>
            <button className="btn btn-primary" disabled={envoi}>{envoi ? 'Création…' : 'Créer le club'}</button>
            <button type="button" className="btn btn-secondary" onClick={() => { setCreation(false); setF({}); }}>Annuler</button>
          </div>
        </form>
      )}

      <PanneauKwixeo />
      <input type="search" value={recherche} onChange={e => setRecherche(e.target.value)}
             placeholder="Rechercher : nom, ville, code FFHandball, email…" aria-label="Rechercher un club"
             style={{ ...champ, marginBottom:12 }} />
      <div className="section-title">{actifs.length} club{actifs.length > 1 ? 's' : ''}{recherche ? ' trouvé' + (actifs.length > 1 ? 's' : '') : ''}</div>
      {actifs.map(carte)}
      {recherche && actifs.length === 0 && suspendus.length === 0 && (
        <div style={{ fontSize:13, color:'var(--muted)', padding:'8px 2px' }}>Aucun club ne correspond à « {recherche} ».</div>)}
      {suspendus.length > 0 && (
        <div style={{ marginTop:14 }}>
          <button type="button" onClick={() => setVoirSuspendus(v => !v)} aria-expanded={afficherSuspendus}
                  style={{ background:'none', border:'none', color:'var(--muted)', cursor:'pointer', fontSize:12.5,
                           fontWeight:700, letterSpacing:.5, padding:'6px 0' }}>
            {afficherSuspendus ? '▾' : '▸'} {suspendus.length} club{suspendus.length > 1 ? 's' : ''} suspendu{suspendus.length > 1 ? 's' : ''}
          </button>
          {afficherSuspendus && <div style={{ marginTop:6 }}>{suspendus.map(carte)}</div>}
        </div>)}
    </>
  );
}

// ── Dépannage ───────────────────────────────────────────────────────────────
function Depannage({ notifier }) {
  const [q, setQ]           = useState('');
  const [res, setRes]       = useState(null);
  const [acces, setAcces]   = useState(null);

  async function chercher(e) {
    e.preventDefault();
    if (q.trim().length < 2) return;
    try { setRes(await rechercherCompte(q.trim())); } catch (err) { notifier(err.message, 'error'); }
  }

  async function reinitialiser(u) {
    if (!window.confirm(`Générer un nouveau mot de passe pour ${u.username} ?`)) return;
    try { const r = await resetMdpEditeur(u.id); setAcces({ username: r.username, password: r.motdepasse }); }
    catch (err) { notifier(err.message, 'error'); }
  }

  async function changerRole(u, role) {
    try {
      const r = await roleCompte(u.id, role);
      notifier(r.sans_equipe
        ? 'Rôle modifié — attention, ce compte n\'est rattaché à aucune équipe : rattachez-le depuis Mon club'
        : 'Rôle modifié', r.sans_equipe ? 'error' : 'success');
      setRes(await rechercherCompte(q.trim()));
    } catch (err) { notifier(err.message, 'error'); }
  }

  async function basculer(u) {
    try {
      await activerCompte(u.id, !u.actif);
      notifier(u.actif ? 'Compte suspendu' : 'Compte réactivé');
      setRes(await rechercherCompte(q.trim()));
    } catch (err) { notifier(err.message, 'error'); }
  }

  return (
    <>
      {acces && <Identifiants titre="Nouveau mot de passe" username={acces.username}
                              password={acces.password} onFermer={() => setAcces(null)} />}
      <form onSubmit={chercher} style={{ display:'flex', gap:8, marginBottom:16 }}>
        <input style={champ} value={q} onChange={e => setQ(e.target.value)}
               placeholder="Nom, prénom, identifiant ou email" autoFocus />
        <button className="btn btn-primary" style={{ width:'auto', padding:'0 18px' }}>Chercher</button>
      </form>

      {res && res.length === 0 && <div className="card" style={{ color:'var(--muted)', textAlign:'center' }}>Aucun compte trouvé</div>}
      {res && res.map(u => (
        <div key={u.id} className="card" style={{ marginBottom:8, opacity: u.actif ? 1 : .6 }}>
          <div style={{ display:'flex', justifyContent:'space-between', gap:10, flexWrap:'wrap' }}>
            <div>
              <div style={{ fontSize:14, fontWeight:700 }}>{u.prenom ? `${u.prenom} ${u.nom}` : u.username}</div>
              <div style={{ fontSize:11.5, color:'var(--muted)', marginTop:2 }}>
                {u.username} · {ROLE[u.role] || u.role} · {u.club_nom || 'hors club'}{u.email ? ` · ${u.email}` : ''}
                {!u.actif && <span style={{ color:'var(--danger)' }}> · suspendu</span>}
              </div>
            </div>
            {u.role !== 'super_admin' && (
              <div style={{ display:'flex', gap:6, flexWrap:'wrap', alignItems:'center' }}>
                {u.club_id && (
                  <select value={{ admin:'admin_club', admin_3mt:'tresorier' }[u.role] || u.role}
                          onChange={e => changerRole(u, e.target.value)} aria-label="Rôle du compte"
                          style={{ background:'var(--bg)', color:'var(--text)', border:'1px solid var(--border)',
                                   borderRadius:8, padding:'7px 8px', fontSize:11.5 }}>
                    <option value="admin_club">Admin club</option>
                    <option value="coach">Coach</option>
                    <option value="tresorier">Trésorier</option>
                    <option value="joueur">Joueur</option>
                  </select>
                )}
                <button className="btn btn-secondary" style={{ width:'auto', padding:'7px 11px', fontSize:11.5 }}
                        onClick={() => reinitialiser(u)}>🔑 Mot de passe</button>
                <button className="btn btn-secondary" style={{ width:'auto', padding:'7px 11px', fontSize:11.5 }}
                        onClick={() => basculer(u)}>{u.actif ? 'Suspendre' : 'Réactiver'}</button>
              </div>
            )}
          </div>
        </div>
      ))}
    </>
  );
}
